import { type ReactElement, useEffect, useState } from 'react';
import { ApplicationsService } from '@/services/ApplicationsService.ts'
import { type ApplicationsDto, type ApplicationDto, type FullApplicationsDto, type AppServicesDto, type AppServicesEnvDto, type EnvironmentClass, type ApplicationsKearDto, type ApplicationKearDto } from '@/models/services.ts'
import { type APIEntryDto } from '@/models/apiConfiguration.ts'
import Loading from '../common/Loading.tsx';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import NoValue from '../common/NoValue.tsx';
import { toastError, toastInfo } from '@/components/common/toast';
import  "./applicationList.css"
import { Link } from 'react-router-dom';

export function ApplicationList(): ReactElement {

    
    const [applications, setApplications] = useState<ApplicationKearDto[] | null>(null);
    const [applicationsSaved, setApplicationsSaved] = useState<ApplicationKearDto[] | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showOnlyMineApp, setShowOnlyMineApp] = useState<boolean>(false);
    const [showOnlyFavoriteApp, setShowOnlyFavoriteApp] = useState<boolean>(false);
    
    const [filter, setFilter] = useState<string>("");
    const [readonly, SetReadonly] = useState<boolean>(false);
    const [selectedApplication, setSelectedApplication] = useState<FullApplicationsDto | null>(null);

    const RefreshData = () => {
        setIsLoading(true);
        new ApplicationsService().getAllApplications().then((applications: ApplicationsKearDto) => {
            setIsLoading(false);
            setApplications(applications.applications);
            setApplicationsSaved(applications.applications);
        });
    };

    useEffect(() => {
        RefreshData();
    }, []);
  
    const setShowSearchText = (value: string) => {
        setFilter(value);
        FilterData(value, showOnlyMineApp, showOnlyFavoriteApp);
    }

    const showOnlyMine = (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        setShowOnlyMineApp(checked);
        setShowOnlyFavoriteApp(false);
        FilterData(filter, checked, false);

    }

    const showOnlyFavorite = (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        setShowOnlyMineApp(false);
        setShowOnlyFavoriteApp(checked);
        FilterData(filter, false, checked);

    }
    
    const ToggleBookmarks = (e: any, application: ApplicationKearDto, currentStatus: boolean) => {
      e.stopPropagation();
      e.preventDefault();
      new ApplicationsService().toggleBookmarks(application.globalIdentifier, currentStatus).then((result: boolean) => {
          RefreshData();
          if (currentStatus) {
              toastInfo("Bookmark has been added");
          }
          else {
            toastInfo("Bookmark has been removed");
        }
      });
      return false;
    }

    const FilterData = (value: string, showOnlyMine: boolean, showOnlyFavoriteApp: boolean) => {
        console.log(value+","+showOnlyMine+","+showOnlyFavoriteApp)
        if (applications) {
            const filteredApps = applicationsSaved?.filter((app: ApplicationKearDto) => app.applicationName.toLowerCase().includes(value.toLowerCase()));

            if(showOnlyFavoriteApp) {
                setApplications(filteredApps?.filter((app: ApplicationKearDto) => app.isBookmarked) ?? []);
                return;
            }
            if(showOnlyMine) {
                setApplications(filteredApps?.filter((app: ApplicationKearDto) => app.userInTeam) ?? []);
                return;
            }
            setApplications(filteredApps ?? []);
        } else {
            setApplications(null);
        }
    }

    return (
        <div>
            <h2>Filters:</h2>
            <Row>
            <Col md="6">
                    <div className="form-group">
                        <label htmlFor="searchText" className="form-label">Search</label>
                        <input type="text" className="form-control" id="searchText" placeholder="Search..." onChange={(e) => setShowSearchText(e.target.value)} />
                    </div>
                </Col>
                <Col md="2" className='pt-4'>
                    <div className="form-group form-check">
                        <input type="checkbox" className="form-check-input"  onChange={(e) => showOnlyMine(e)} checked={showOnlyMineApp}/>
                        <label className="form-check-label" >Only show mine</label>
                    </div>
                </Col>
                <Col md="4" className='pt-4'>
                    <div className="form-group form-check">
                        <input type="checkbox" className="form-check-input"  onChange={(e) => showOnlyFavorite(e)} checked={showOnlyFavoriteApp}/>
                        <label className="form-check-label" >Only show favorite</label>
                    </div>
                </Col>
            </Row>
            <h2 className='mt-4'>Applications</h2>
            <Row className='mt-2'>
                {isLoading ? <Loading isLoading={isLoading} /> : 
                <>
                {applications && applications?.map((application: ApplicationKearDto) => {

                    return (
                        <Col md="4" key={`app-${application.globalIdentifier}`}>
                        <Link to={`/applications/${application.globalIdentifier}`} className="card component-card card-raising card-bordered mb-4 w-100 card-high" style={{ height: '240px' }} >
                            <div className="card-body">
                                <div className="text-large d-flex justify-content-between align-items-start">
                                    <div style={{ width: "calc(76.00%)", lineHeight:"23px"}}>
                                        {readonly ? <span className="material-icons-round" style={{width: "23px", verticalAlign:"bottom"}}></span> : <span className="material-icons-round" style={{verticalAlign:"bottom"}} onClick={(e) => ToggleBookmarks(e, application, application.isBookmarked)} title={application.isBookmarked ? "Remove bookmark":"Add to bookmark"}>{application.isBookmarked ? 'bookmark' : 'bookmark_outline'}</span> }
                                        <span><em className="icon text-info">settings_backup_restore</em> <span className="card-title line-height-1 mb-0 ellipsis-2 text-uppercase app-title">{application.applicationName}</span></span>
                                        
                                    </div>
                                </div>
                                <div className="card-text ellipsis-2 text-small text-secondary mb-4">
                                    <span>{application.managerDepartment}</span>
                                </div>
                                <div className="card-text ellipsis-2 mt-4 mb-4">
                                    <span>{application.description}</span>
                                </div>
                            </div>
                            <div className="card-footer pb-0 position-absolute bottom-0 mt-2 mb-3 w-100">
                                <div className="row">
                                    <div className="col-10">
                                        <span className="badge badge-sm badge-discreet-primary badge-prepend-square badge-discreet-success me-1 ellipsis"> {application.lifeCycle} </span>
                                        <span className="badge badge-sm badge-prepend-square card-raising badge-discreet-primary ellipsis"> {application.status} </span>
                                    </div>
                                </div>
                            </div>
                        </Link>
                        </Col>
                    );
                })}
                </>
                }
            </Row>
        </div>
    );

}